import React, { useState } from 'react';
import OLEDCalculator from './OLEDCalculator';
import OLEDConspectFull from './OLEDConspectFull';
import './App.css';

function App() {
  const [view, setView] = useState('conspect'); // 'conspect' або 'calculator'
  
  return (
    <div className="App">
      {/* Перемикач режимів */}
      <div style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        zIndex: 1000,
        background: 'white',
        padding: '10px',
        borderRadius: '10px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
      }}>
        <button
          onClick={() => setView('conspect')}
          style={{
            padding: '10px 20px',
            marginRight: '10px',
            background: view === 'conspect' ? '#667eea' : '#f5f5f5',
            color: view === 'conspect' ? 'white' : '#333',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            transition: 'all 0.3s'
          }}
        >
          📚 Конспект
        </button>
        <button
          onClick={() => setView('calculator')}
          style={{
            padding: '10px 20px',
            background: view === 'calculator' ? '#667eea' : '#f5f5f5',
            color: view === 'calculator' ? 'white' : '#333',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            transition: 'all 0.3s'
          }}
        >
          🧮 Калькулятор
        </button>
      </div>
      
      {view === 'conspect' ? <OLEDConspectFull /> : <OLEDCalculator />}
    </div>
  );
}

export default App;
